import React, { PropsWithChildren } from 'react';
import { useZodForm } from '@/shared/hooks/useZodForm.ts';
import {
    customRequestProductSchemaDefaults,
    useCustomRequestProductSchema,
} from '@/CustomRequestProductChannel/hooks/useCustomRequestProductSchema.ts';
import { FormProvider } from 'react-hook-form';
import { z, ZodSchema } from 'zod';
import { PRODUCT_TYPES } from '@schuettflix/interfaces';

type CustomRequestProductFormProviderProps = PropsWithChildren & {
    intersectionSchema?: ZodSchema;
    product: { type: PRODUCT_TYPES };
};

export function CustomRequestProductFormProvider({
    children,
    intersectionSchema,
    product,
}: CustomRequestProductFormProviderProps) {
    const customRequestProductSchema = useCustomRequestProductSchema(product);
    const mergedSchema = intersectionSchema
        ? z.intersection(customRequestProductSchema, intersectionSchema)
        : customRequestProductSchema;

    const methods = useZodForm({
        schema: mergedSchema,
        defaultValues: customRequestProductSchemaDefaults,
        mode: 'onChange',
    });

    return <FormProvider {...methods}>{children}</FormProvider>;
}
